<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label-width
                          prop="buyer_nick"
                          label="客户昵称">
              <el-input v-model="form.buyer_nick"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="level"
                          label="等级">
              <!-- <el-input v-model="form.level"></el-input> -->
              <number-range v-model="form.level" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="from"
                          label="来源">
              <el-input v-model="form.from"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <el-date-picker v-model="form.create_time"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              style="width: 100%"
              border>
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"></el-table-column>
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="客户昵称"></el-table-column>
      <el-table-column prop="level"
                       align="center"
                       header-align="center"
                       label="等级"></el-table-column>
      <el-table-column prop="from"
                       align="center"
                       header-align="center"
                       label="来源"></el-table-column>
      <el-table-column prop="name"
                       align="center"
                       header-align="center"
                       label="您的姓名"></el-table-column>
      <el-table-column prop="gender"
                       align="center"
                       header-align="center"
                       label="您的性别"></el-table-column>
      <el-table-column prop="marry"
                       align="center"
                       header-align="center"
                       label="您的婚姻状况"></el-table-column>
      <el-table-column prop="birthday"
                       align="center"
                       header-align="center"
                       label="您的出生年月日"
                       width="100px"></el-table-column>
      <el-table-column prop="job"
                       align="center"
                       header-align="center"
                       label="您的职业"></el-table-column>
      <el-table-column prop="income"
                       align="center"
                       header-align="center"
                       label="您的月收入"></el-table-column>
      <el-table-column prop="city"
                       align="center"
                       header-align="center"
                       label="您所在的省市是？（必选）填写例：山东省威海市"></el-table-column>
      <el-table-column prop="mobile"
                       align="center"
                       header-align="center"
                       label="您的手机号"
                       width="110px"></el-table-column>
      <el-table-column prop="email"
                       align="center"
                       header-align="center"
                       label="你的邮箱是?"
                       width="120px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="get_info"
                       align="center"
                       header-align="center"
                       label="是否愿意接受佳能的一些特价会员专享信息？"></el-table-column>
      <el-table-column prop="lens_num"
                       align="center"
                       header-align="center"
                       label="您拥有镜头数量"></el-table-column>
      <el-table-column prop="equipment"
                       align="center"
                       header-align="center"
                       label="您最常使用的摄影器材？"></el-table-column>
      <el-table-column prop="camera_model"
                       align="center"
                       header-align="center"
                       label="您已有的摄影器材品牌及型号？填写例佳能-700D"></el-table-column>
      <el-table-column prop="like_brand"
                       align="center"
                       header-align="center"
                       label="您还对其他品牌或型号的摄影器材感兴趣？填写例尼康-D300或"></el-table-column>
      <el-table-column prop="theme"
                       align="center"
                       header-align="center"
                       label="您经常拍摄的主题是？"></el-table-column>
      <el-table-column prop="frequency"
                       align="center"
                       header-align="center"
                       label="您摄影的频率是？"></el-table-column>
      <el-table-column prop="standard"
                       align="center"
                       header-align="center"
                       label="您的拍摄水平是？"></el-table-column>
      <el-table-column prop="like_gift"
                       align="center"
                       header-align="center"
                       label="您喜欢的赠品是？填写例：SD卡，摄影包，三脚架"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   // dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/memberquescustom/index.vue